var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-display-flex gl-align-items-flex-start gl-flex-direction-column gl-md-flex-direction-row gl-gap-3 gl-pt-3"},[_c('h1',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.titleHtml),expression:"titleHtml"}],staticClass:"title gl-font-size-h-display gl-m-0!",class:{
      'issue-realtime-pre-pulse': _vm.preAnimation,
      'issue-realtime-trigger-pulse': _vm.pulseAnimation,
    },attrs:{"data-testid":"issue-title","dir":"auto"}}),_vm._v(" "),_vm._t("actions")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }